<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view />
</template>

<script>
import { userStore } from "@/store/user.js";
import { CUSTOMER_PAGE_PATH_LIST } from "@/router/index.js";
import { isJuzi } from "@/util/platform.js";

// import VConsole from "vconsole";

export default {
  name: "App",
  data() {
    return {};
  },
  components: {},
  setup() {},
  mounted() {

    // new VConsole();
    
    //当前路由名称
    const { pathname } = window.location;
    /**
     * 20240912-获客码
     * 现在员工和顾客都用了企微的web
     * 顾客的页面就不需要走员工的逻辑
     */
    //顾客页面列表

    if (CUSTOMER_PAGE_PATH_LIST.includes(pathname)) {
      //顾客
      console.log("顾客访问-path", pathname);
    } else {
      //员工
      const user = userStore();
      
      // ★ 橘子平台：corpId/agentId 从 OAuth 回调获取，不需要从URL解析
      if (!isJuzi()) {
        //设置带过来的企业ID和应用ID
        user.setAgentIdCorpId();
        //设置微信APPid;
        user.setwxAppid();
        user.wxLogin();
      } else {
        // 橘子平台登录流程由 user store 统一处理。
        user.initJuziLogin();
      }
    }
  },
  methods: {
    //判断是否有用户信息进行微信授权
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
